export function convertTextToLink(text) {
  // Regular expression to find URLs
  const pattern = /(https?:\/\/[^\s]+)/g;
  // Replace URLs with anchor tags
  const replacement = '<a href="$1" target="_blank">$1</a>';
  // Return the converted text
  return text.replace(pattern, replacement);
}
